module.exports = __webpack_public_path__ + "assets/img/qrCode.c4a3be2a.png";